import Axios from "axios";
import User from "./User";
import store from "../src/store";
import { Category } from "./Services";

class RequestCategoriesClass {

  constructor() {
    this.categories = /** @type {Category[]} */ ([]);
    this._lock = false;
  }

  /**
   * @private
   */
  async init() {
    if (!User.token || this._lock) {
      return;
    }
    this._lock = true;
    let categories = await Axios.get(CONFIG.urlServer + "/api/request_categories", {
      params: {
        property: store.state.property,
        perPage: -1
      },
      headers: {
        "Authorization": "Bearer " + User.token
      }
    });
    this.categories = categories.data.data.map(c => new RequestCategory(c));
    this._lock = false;
  }

  findByParent(parent = null) {
    return this.categories.filter(e => e.parent === parent)
  }
}

/**
 * @typedef RequestCategoryDefinition
 * @property {number} id
 * @property {{fr: string, en: string}} name
 * @property {number} parent
 * @property {boolean} deleted
 */

export class RequestCategory {

  /**
   * @param {RequestCategoryDefinition} definition
   */
  constructor(definition) {
    this.id = definition.id;
    this.name = definition.name;
    this.parent = definition.parent;
    this.deleted = definition.deleted;
  }

}

let RequestCategories = new RequestCategoriesClass();
export default RequestCategories;